import * as Yup from 'yup';
import { emailSchema } from 'utils/validation';
import withFormSubmission, { MergedProps } from 'components/common/withFormSubmission';

export interface IValues {
  email: string;
}

export interface IProps {
  onSubmit: (values: IValues) => void;
}

export type FormComponentProps = MergedProps<IProps, IValues>;

const withMagicLinkLoginForm = withFormSubmission<IProps, IValues>({
  validationSchema: () =>
    Yup.object({
      email: emailSchema().required(),
    }),
  mapPropsToValues: () => ({
    email: '',
  }),
  handleSubmit: (values, { props: { onSubmit } }) => {
    onSubmit(values);
  },
});

export default withMagicLinkLoginForm;
